// extracted by mini-css-extract-plugin
export default {"div":"BannerCondia_div__y6fw3","p1":"BannerCondia_p1__LQHTV","p2":"BannerCondia_p2__cTSPJ"};